import { Component, OnInit, ViewChild, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { Ad1Component } from '../advertisement-steps/ad1/ad1.component';
import { Ad2Component } from '../advertisement-steps/ad2/ad2.component';
import { Ad3Component } from '../advertisement-steps/ad3/ad3.component';
import { Ad4Component } from '../advertisement-steps/ad4/ad4.component';
import { Ad5Component } from '../advertisement-steps/ad5/ad5.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NeproseService } from '../services/neprose.service';
import { Location, isPlatformBrowser } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SeoSocialShareService, SeoSocialShareData } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-advertisement',
  templateUrl: './add-advertisement.component.html',
  styleUrls: ['./add-advertisement.component.css']
})
export class AddAdvertisementComponent implements OnInit, AfterViewInit {

  isBrowser: boolean

  constructor(private _route: ActivatedRoute, private _router: Router, private _neproseService: NeproseService, private location: Location,
    @Inject(PLATFORM_ID) platformId: Object, private notification: MatSnackBar, private seo: SeoSocialShareService, private route: ActivatedRoute) {
    this.isBrowser = isPlatformBrowser(platformId)
  }

  @ViewChild(Ad1Component, { static: false }) ad1Component: Ad1Component

  @ViewChild(Ad2Component, { static: false }) ad2Component: Ad2Component

  @ViewChild(Ad3Component, { static: false }) ad3Component: Ad3Component

  @ViewChild(Ad4Component, { static: false }) ad4Component: Ad4Component

  @ViewChild(Ad5Component, { static: false }) ad5Component: Ad5Component


  step: string

  firstFormValid: any

  formSubmitted: boolean = true

  ad: any = {
    id: 1
  }

  count: number = 3

  interval: any

  propertyTypes = []

  seoData: SeoSocialShareData = {
    title: 'Add an Advertisement',
    description: 'Add your property to our domain and get better responses.',
    image: environment.url + '/assets/logo.png'
  };

  listingFor: string

  propertyType: string

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.route.data.subscribe((data: { propertyTypes: any }) => {
      this.propertyTypes = data.propertyTypes
    })
  }

  checkValidation(step) {
    let validStep = 'step-1'
    if (step == 'final-step') {
      if (this.ad1Component.firstAdForm.valid && this.ad2Component.secondAdForm.valid && this.ad3Component.thirdAdForm.valid && this.ad5Component.fifthAdForm.valid) {
        validStep = 'final-step'
      }
    }
    if (step == 'step-5') {
      if (this.ad1Component.firstAdForm.valid && this.ad2Component.secondAdForm.valid && this.ad3Component.thirdAdForm.valid) {
        validStep = 'step-5'
      }
    }
    if (step == 'step-4') {
      if (this.ad1Component.firstAdForm.valid && this.ad2Component.secondAdForm.valid && this.ad3Component.thirdAdForm.valid) {
        validStep = 'step-4'
      }
    }
    if (step == 'step-3') {
      if (this.ad1Component.firstAdForm.valid && this.ad2Component.secondAdForm.valid) {
        validStep = 'step-3'
      }
    }
    if (step == 'step-2') {
      if (this.ad1Component.firstAdForm.valid) {
        this.listingFor = this.ad1Component.firstAdForm.value.listingFor
        this.propertyType = this.propertyTypes.find(property => property.id == this.ad1Component.firstAdForm.value.property_type_id).type
        validStep = 'step-2'
      }
    }
    return validStep
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.changeStep(this.checkValidation(this._route.snapshot.params.step))
    })
  }

  changeStep($event) {
    let step = this.checkValidation($event)
    if (step) {
      this.location.go('/add-property/' + step)
      if (this.isBrowser) {
        window.scroll({
          top: 100,
          left: 100,
          behavior: 'smooth'
        })
      }
      this.step = step
      if (this.step == 'final-step') {
        this.submitAdvertisement()
      }
    }
  }

  submitAdvertisement() {
    let form1 = this.ad1Component.firstAdForm.value
    let form2 = this.ad2Component.secondAdForm.value
    let form3 = this.ad3Component.thirdAdForm.value
    let form5 = this.ad5Component.fifthAdForm.value
    let imageFiles = this.ad4Component.galleryImages
    let formData = new FormData()
    for (var key in form1) {
      if (form1[key]) {
        formData.append(key, form1[key]);
      }
    }
    for (var key in form2) {
      if (form2[key]) {
        if (key == 'distFromRoad') {
          formData.append(key, form2[key] + ' ' + this.ad2Component.selectedUnitDistance);
        } else {
          formData.append(key, form2[key]);
        }
      }
    }
    for (var key in form3) {
      if (form3[key]) {
        if (key != 'bigha' && key != 'kattha' && key != 'dhur' && key != 'kanwa' && key != 'ropani' && key != 'aana' && key != 'paisa' && key != 'daam') {
          formData.append(key, form3[key]);
        }
      }
    }
    for (var key in form5) {
      if (form5[key]) {
        formData.append(key, form5[key]);
      }
    }
    if (imageFiles.length > 0) {
      for (var file of imageFiles) {
        formData.append('images', file)
      }
    }
    this._neproseService.addAdvertisement(formData).subscribe(data => {
      this.formSubmitted = true
      if (data.property) {
        this.ad = data.property
        this.startCounter()
      } else {
        this.changeStep('step-1')
        if (data.message) {
          this.openNotification(data.message)
        }
      }
    }, error => {
      this.formSubmitted = true
      if (error.error.error) {
        this.openNotification(error.error.error)
      }
      if (error.error.message) {
        this.openNotification(error.error.message)
      }
    })
  }

  startCounter() {
    this.interval = setInterval(() => {
      this.count--
    }, 1000)
    setTimeout(() => {
      this._router.navigate(['/property/' + this.ad.id + '/payment'])
    }, 3000)
  }

  openNotification(message) {
    this.notification.open(message, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }


}
